import clsx from 'clsx';
import {InputHTMLAttributes, ReactNode} from 'react';
import ValidationMessage from '@/ui/ValidationMessage';
import styles from './styles.module.scss';

export interface ICheckboxProps {
    label?: ReactNode | null;
    error?: string | null;
    checkboxProps?: InputHTMLAttributes<HTMLInputElement>;
    wrapperStyles?: string[];
    labelStyles?: string[];
}

const Checkbox = ({
    label = null,
    error = null,
    checkboxProps = {},
    wrapperStyles = [],
    labelStyles = []
}: ICheckboxProps) => {
    return (
        <div className={clsx(styles.wrapper, ...wrapperStyles)}>
            <label className={clsx(styles.label, ...labelStyles)}>
                <input
                    {...checkboxProps}
                    type={'checkbox'}
                    className={clsx(styles.checkbox, !!error && styles.hasError)}
                />
                {!!label && label}
            </label>
            <ValidationMessage error={error} errorStyles={[styles.error]} />
        </div>
    );
};

export default Checkbox;
